import LocalStore from '../utils/localstore'
import {decrypt,encrypt} from '../utils/aes'
import {CONNECT,PUBLISH,FP, UPUI, MP, MS, KEY_VUE_USER_ID, KEY_VUE_DEVICE_ID, DISCONNECT, GPGI, GQNUT, US, FAR, FRP, FHR, MMI, GPGM, GC, GQ, PUB_ACK, ERROR_CODE, MR, GAM, GMI, GKM, GD, GMURL} from '../constant/system'
import {WebSocketProtoMessage} from './message/websocketprotomessage'
import ConnectAckHandler from './handler/connectackhandler';
import {WS_PROTOCOL,WS_IP,WS_PORT,HEART_BEAT_INTERVAL,RECONNECT_INTERVAL,BINTRAY_TYPE} from '../constant/config'
import vuexStore from '../../vuex'
import PromiseResolve from './future/promiseResolve';
import FutureResult from './future/futureResult';
import GetFriendResultHandler from './handler/getfriendresultHandler';
import GetUserInfoHandler from './handler/getuserinfoHandler';
import ReceiveMessageHandler from './handler/receiveMessageHandler';
import GetGroupInfoHandler from './handler/getGroupInfoHandler';
import NotifyMessageHandler from './handler/notifyMessageHandler';
import GetUploadTokenHandler from './handler/getUploadtokenHandler'
import GetGroupMemberHandler from './handler/getGroupMemberHandler';
import GetMinioUploadUrlHandler from './handler/getMinioUploadUrlHandler';
import SendMessageHandler from './handler/sendMessageHandler';
import NotifyRecallMessageHandler from './handler/notifyRecallMessageHandler';
export default class WebSocketClient {
    handlerList = [];
    userDisconnect = false;
    isconnected = false;
    resolvePromiseMap = new Map();

    constructor(){
        this.ws_protocol = WS_PROTOCOL;
        this.ip= WS_IP;
        this.port = WS_PORT;
        this.heartbeatTimeout = HEART_BEAT_INTERVAL;
        this.reconnectInterval = RECONNECT_INTERVAL;
        this.binaryType = BINTRAY_TYPE;
        this.url = WS_PROTOCOL + '://' + WS_IP;
        this.initHandlerList();
        this.connect(true); 
    }

    connect(isReconncect){
        this.ws = new WebSocket(this.url);
        console.log("current url "+this.url+" status "+this.ws.readyState);
        this.ws.binaryType = this.binaryType;
        var websocketObj = this;
        this.ws.onopen = function (event) {
            console.log("ws open");
            websocketObj.isconnected = true;
            websocketObj.lastInteractionTime(new Date().getTime());
            websocketObj.pingIntervalId = setInterval(() => {
                 websocketObj.ping();
             }, websocketObj.heartbeatTimeout);
             websocketObj.userDisconnect = false;
             //发送connect指令
             websocketObj.sendConnectMessage();
        }
        this.ws.onmessage = function(event) {
            console.log("ws onmessage["+event.data+"]");
            websocketObj.processMessage(event.data);
            websocketObj.lastInteractionTime(new Date().getTime());
        }
        this.ws.onclose = function(event) {
            websocketObj.isconnected = false;
            console.log("ws onclose");
            websocketObj.ws.close();
            clearInterval(websocketObj.pingIntervalId);
            if(!websocketObj.userDisconnect){
                console.log("reconnect websocket");
                websocketObj.reconnect(event);
            }
        }
        this.ws.onerror = function(event) {
            console.log("connect error");
        }
    }

    reconnect(event){
        var websocketObj = this;
        setTimeout(() => {
            websocketObj.connect(true);
        }, this.reconnectInterval);
    }

    initHandlerList(){
        this.handlerList.push(new ConnectAckHandler(this));
        this.handlerList.push(new GetFriendResultHandler(this))
        this.handlerList.push(new GetUserInfoHandler(this))
        this.handlerList.push(new ReceiveMessageHandler(this))
        this.handlerList.push(new GetGroupInfoHandler(this))
        this.handlerList.push(new NotifyMessageHandler(this))
        this.handlerList.push(new GetUploadTokenHandler(this))
        this.handlerList.push(new GetGroupMemberHandler(this))
        this.handlerList.push(new GetMinioUploadUrlHandler(this))
        this.handlerList.push(new SendMessageHandler(this))
        this.handlerList.push(new NotifyRecallMessageHandler(this))
    }

    lastInteractionTime(actionTime){
        this.actionTime = actionTime;
    }

    getLastActionTime(){
        return this.actionTime;
    }

    ping(){
        this.send('心跳内容')
    }

    /**
     * 分发vuex action
     */
    sendAction(type,data){
        vuexStore.dispatch(type,data);
    }

    send(data){
        console.log("send message "+data);
        if(this.isconnected){
            this.ws.send(data);
        } else {
            console.log("curent websocket is close");
        }
        
    }

    processMessage(data){
        var protoObj = JSON.parse(data);
        for(var i = 0; i < this.handlerList.length; i++){
            if(this.handlerList[i].match(protoObj)){
                 this.handlerList[i].processMessage(protoObj);
            }
        }
    }


    /**
     * 链接建立信息
     */
    sendConnectMessage(){
        console.log("userToken "+LocalStore.getToken());
        let allToken = decrypt(LocalStore.getToken());
        console.log("decryptToken "+allToken);
        let pwd = allToken.substring(0,allToken.indexOf('|'));
        allToken = allToken.substring(allToken.indexOf('|')+1);
        let secret = allToken.substring(0,allToken.indexOf('|'));
        console.log('[pwd]->'+pwd+' [secret]->'+secret);
        let pwdAesBase64 = encrypt(pwd,secret);
        console.log('encrypt pwd: '+pwdAesBase64);

        var websocketprotomessage =  new WebSocketProtoMessage();
        console.log("deviceid "+LocalStore.getDeviceId())
        websocketprotomessage.setSignal(CONNECT);
        var connectMessage = {
            userName: LocalStore.getUserId(),
            password: pwdAesBase64,
            clientIdentifier: LocalStore.getDeviceId()
        }
        websocketprotomessage.content = connectMessage;
        console.log(websocketprotomessage.toJson());
        this.send(websocketprotomessage.toJson());
    }

    sendDisConnectMessage(){
        var websocketprotomessage = new WebSocketProtoMessage();
        websocketprotomessage.setSignal(DISCONNECT);
        var disconnectMessage = {
            clearSession : 1
        }
        websocketprotomessage.content = disconnectMessage;
        console.log(websocketprotomessage.toJson());
        this.send(websocketprotomessage.toJson());
        this.userDisconnect = true;
    }


    /**
     * 获取朋友列表
     */
    getFriend(){
        this.sendPublishMessage(FP,{version : 0});
    }

    /**
     * 获取用户详细信息
     * @param userIds 要获取的用户id数组
     */
    getUserInfos(userIds){
        this.sendPublishMessage(UPUI,userIds);
    }

    /**
     * 获取单个用户的信息
     * @param  userId 
     */
    async getUserInfo(userId){
        var promise = await this.sendPublishMessage(UPUI,[userId]);
        return promise
    }

    async getGroupMember(groupId,refresh){
        return await this.sendPublishMessage(GPGM,{
            groupId: groupId,
            version: 0
        })
     }

    pullMessage(messageId,type = 0,pullType = 0,sendMessageCount = 0){
        this.sendPublishMessage(MP,{
            messageId: messageId,
            type: type,
            pullType : pullType,
            sendMessageCount: sendMessageCount
        });
    }

    /**
     * 
     * @param {群组id} groupId 
     * @param {是否需要刷新} refresh 
     */
    getGroupInfo(groupId,refresh){
        var groupIds = [];
        groupIds.push(groupId);
        this.sendPublishMessage(GPGI,groupIds);
    }

    async getUploadToken(mediaType){
        var content = {
         mediaType: mediaType
        };
        return await this.sendPublishMessage(GQNUT,content);
     }

    async getMinioUploadUrl(mediaType,key){
        var content = {
            mediaType: mediaType,
            key: key
        }
        return await this.sendPublishMessage(GMURL,content)
    } 

/**
     * 
     * @param {子信令} subsignal 
     * @param {消息体内容} content 
     */
    sendPublishMessage(subsignal,content,protoMessageId = 0){
        var websocketprotomessage = new WebSocketProtoMessage();
        websocketprotomessage.setSignal(PUBLISH);
        websocketprotomessage.setSubSignal(subsignal);
        websocketprotomessage.setContent(content);
        var messageId = LocalStore.getMessageId();
        if(messageId > 65535){
            messageId = 0;
        }
        websocketprotomessage.setMessageId(++messageId);
        LocalStore.saveMessageId(messageId);
        this.send(websocketprotomessage.toJson());
        
        var vueWebSocket = this;
        var pubAckPromise = new Promise((resolve) => {
             var timeoutId = setTimeout(() => {
                 if(subsignal == MS){
                    var failProtoMessage = new WebSocketProtoMessage();
                    failProtoMessage.setSignal(PUB_ACK);
                    failProtoMessage.setSubSignal(subsignal)
                    failProtoMessage.setMessageId(messageId);
                    failProtoMessage.setContent('')
                    vueWebSocket.processMessage(failProtoMessage.toJson())
                 } else {
                    resolve(new FutureResult(ERROR_CODE,""));
                 }
                 
             },10000);
             var resolvePromise = new PromiseResolve(resolve,timeoutId);
             resolvePromise.protoMessageId = protoMessageId;
             vueWebSocket.resolvePromiseMap.set(messageId,resolvePromise);
        });
        return pubAckPromise;
    }


    sendMessage(protoMessage){
        this.sendPublishMessage(MS,protoMessage,protoMessage.messageId);
     }
}


// WEBPACK FOOTER //
// ./src/fscommon/websocket/index.js